import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Controls, validators } from 'shared/helper/form';
import { T } from 'shared/helper/translate';
import RubriqSetupStepBackLink from './RubriqSetupStepBackLink';
var wordLimitHelperMessage = function wordLimitHelperMessage() {
  return /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-criteria-max-length-helper",
    params: {
      maxLimit: '10,000'
    }
  });
};
var characterLimitHelperMessage = function characterLimitHelperMessage() {
  return /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-criteria-max-length-helper",
    params: {
      maxLimit: '80,000'
    }
  });
};
var createMaxNumberValidator = function createMaxNumberValidator(maxNumber) {
  return function (value) {
    return !!value && parseInt(value, 10) <= maxNumber;
  };
};
var wordLimitValidator = createMaxNumberValidator(10000);
var characterLimitValidator = createMaxNumberValidator(80000);
var wordLimitInvalidMessage = function wordLimitInvalidMessage() {
  return /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-criteria-max-length-invalid-error",
    params: {
      maxLimit: '10,000'
    }
  });
};
var characterLimitInvalidMessage = function characterLimitInvalidMessage() {
  return /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-criteria-max-length-invalid-error",
    params: {
      maxLimit: '80,000'
    }
  });
};
var RubriqSetupTextLimitStep = function RubriqSetupTextLimitStep(_ref) {
  var methodsTextLimit = _ref.methodsTextLimit,
    handleSubmit = _ref.handleSubmit,
    useCharacters = _ref.useCharacters,
    submitting = _ref.submitting,
    session = _ref.session,
    previousStep = _ref.previousStep;
  var Form = Controls.Form,
    Text = Controls.Text,
    Select = Controls.Select;
  var notEmpty = validators.notEmpty,
    intGtZero = validators.intGtZero;
  return /*#__PURE__*/React.createElement(Form, {
    methods: methodsTextLimit,
    onSubmit: handleSubmit,
    className: "d-flex flex-column gap-sm-4 justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "m-0 fw-semibold"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.abstract-criteria-text-limit-step-prompt"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column flex-sm-row align-items-start align-items-sm-end gap-sm-2"
  }, /*#__PURE__*/React.createElement(Text, {
    name: "maxLength",
    label: "maximum length",
    validators: {
      notEmpty: notEmpty,
      intGtZero: intGtZero,
      maximumNumber: useCharacters ? characterLimitValidator : wordLimitValidator
    },
    required: false,
    styles: {
      label: 'text-transform-none'
    },
    messages: {
      notEmpty: 'curie.abstract-criteria-max-length-missing-error',
      intGtZero: useCharacters ? characterLimitInvalidMessage : wordLimitInvalidMessage,
      maximumNumber: useCharacters ? characterLimitInvalidMessage : wordLimitInvalidMessage
    },
    description: useCharacters ? characterLimitHelperMessage : wordLimitHelperMessage
  }), /*#__PURE__*/React.createElement(Select, {
    name: "units",
    options: [{
      label: 'curie.abstract-criteria-text-limit-step-words-option',
      value: 'words'
    }, {
      label: 'curie.abstract-criteria-text-limit-step-characters-option',
      value: 'characters'
    }],
    description:
    // make sure both fields are always aligned in the row by rendering a help text (albeit empty)
    function description() {
      return /*#__PURE__*/React.createElement("span", null, "\xA0");
    },
    styles: {
      wrapper: 'mb-sm-3 control-group units-wrapper',
      controls: 'units-control'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between gap-3"
  }, /*#__PURE__*/React.createElement(RubriqSetupStepBackLink, {
    session: session,
    previousStep: previousStep
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary btn-squared py-1 px-sm-5 w-mobile-50",
    disabled: submitting
  }, /*#__PURE__*/React.createElement(T, {
    source: "next"
  }), submitting && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "ms-1",
    spin: true
  }))));
};
export default RubriqSetupTextLimitStep;